import { render } from "./user.vue?vue&type=template&id=53f15040&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=53f15040&scoped=true&lang=css"
import "./user.vue?vue&type=style&index=1&id=53f15040&lang=css"
script.render = render
script.__scopeId = "data-v-53f15040"

export default script